export default __webpack_public_path__ + "static/media/SE-welcome-modal-map-2.8d17a266.jpg";